import { capitalize } from 'lodash';

import { getRoleList } from 'api/Roles';

import Status from 'components/shared/Status/Status';

export const adminsStatuses = [
  {
    value: 'pending',
    label: 'Pending'
  },
  {
    value: 'active',
    label: 'Active'
  },
  {
    value: 'inactive',
    label: 'Inactive'
  }
];

export const adminRoles = [
  {
    value: 'owner',
    label: 'Owner'
  },
  {
    value: 'test',
    label: 'Test'
  }
];

export const defaultColumns = [
  {
    field: 'id',
    headerName: 'ID',
    headerCheckboxSelection: true,
    checkboxSelection: (params) => !params.node.group
  },
  {
    field: 'f_name',
    headerName: 'First Name',
    valueFormatter: ({ value }) => capitalize(value)
  },
  {
    field: 'l_name',
    headerName: 'Last Name',
    valueFormatter: ({ value }) => capitalize(value)
  },
  {
    field: 'email',
    headerName: 'Email'
  },
  {
    field: 'role',
    headerName: 'Role',
    valueFormatter: ({ value }) => capitalize(value)
  },
  {
    field: 'status',
    headerName: 'Status',
    resizable: false,
    cellRenderer: (params) => (
      <td className="flex h-full w-full items-center">
        <Status
          status={params?.data?.status}
          className="h-fit"
          textClassName="block"
          color="primary"
        />
      </td>
    )
  }
];

export const defaultFilters = {
  searchTerm: {
    type: 'search',
    values: null,
    title: 'Admins',
    placeholder: 'Search admins'
  },
  status: {
    type: 'checkbox',
    values: null,
    options: adminsStatuses,
    title: 'Status',
    preview: (values) => values.map((v) => capitalize(v)).join(', ')
  },
  role: {
    type: 'infinite-scroll',
    multiple: true,
    values: [],
    queryKey: 'role_list',
    queryFn: getRoleList,
    params: { forAdmin: true },
    title: 'Roles',
    placeholder: 'Search roles',
    formatData: (data) => [
      ...data.map((role) => ({
        label: role?.name,
        value: role?.id
      }))
    ]
  }
};
